'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _typeof2 = require('babel-runtime/helpers/typeof');

var _typeof3 = _interopRequireDefault(_typeof2);

exports.getRouteSettings = getRouteSettings;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _lodash = require('lodash');

var _reactRouter = require('react-router');

var _auth = require('./redux/actions/auth');

var _modal_type = require('redux/actions/modal_type');

var _confirmation = require('helpers/confirmation');

var _containers = require('./containers');

var _components2 = require('components');

var _AddressList = require('containers/AddressList');

var _AddressList2 = _interopRequireDefault(_AddressList);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var isNeedToShowRegModal = false;

exports.default = function (store) {
    var requireLogin = function requireLogin(nextState, replace, cb) {
        var dispatch = store.dispatch,
            getState = store.getState;

        var _getState = getState(),
            user = _getState.auth.user;

        function checkAuth() {
            var REGEXP_ORDER_ROUTE = /(\/personal\/order\/)[\d]+/g;
            var REGEXP_CREATE_ORDER_ROUTE = /(\/create-order\/)[\d]+/g;

            if (!{ auth: { user: user } } && !REGEXP_ORDER_ROUTE.test(nextState.location.pathname) && !REGEXP_CREATE_ORDER_ROUTE.test(nextState.location.pathname)) {
                // роут для карточки заказа не перекидываем на главную
                replace('/');
            }

            cb();
        }

        if (!(0, _auth.isLoaded)(getState()) && (0, _auth.isLoadedInServer)(getState())) {
            dispatch((0, _auth.load)()).then(checkAuth);
        } else {
            checkAuth();
        }
    };

    var onEnter = function onEnter() {
        _components2.PreloaderGlobal.toogleShow('one_show');
    };

    var onLeave = function onLeave() {
        _components2.PreloaderGlobal.toogleShow('on');
    };

    var onEnterRegPage = function onEnterRegPage(nextState, replace, cb) {
        isNeedToShowRegModal = true;
        if (__CLIENT__) {
            replace('/');
        }
        cb();
    };

    var onEnterMainPage = function onEnterMainPage(nextState, replace, cb) {
        var dispatch = store.dispatch;

        if (isNeedToShowRegModal) {
            dispatch((0, _modal_type.showModalRegistration)());
        }

        isNeedToShowRegModal = false;

        cb();
    };

    var onEnterToOrderDetails = function onEnterToOrderDetails(nextState, replace, cb) {
        var confirmProcessor = new _confirmation.ConfirmationEmailByUrlParamsProcessor(nextState.location, nextState.params, store);
        confirmProcessor.tryToConfirm().then(function () {
            return cb();
        }).catch(function () {
            return cb();
        });
    };
    /**
     * Please keep routes in alphabetical order
     */
    return _react2.default.createElement(
        _reactRouter.Route,
        { path: '/', component: _containers.App, onEnter: onEnterMainPage },
        _react2.default.createElement(_reactRouter.IndexRoute, { component: _containers.Main, onEnter: onEnter, onLeave: onLeave }),
        _react2.default.createElement(
            _reactRouter.Route,
            { component: _containers.CheckAuth, onEnter: requireLogin },
            _react2.default.createElement(_reactRouter.Route, { path: 'create-order/:order_id', component: _containers.CreateOrder, onEnter: onEnterToOrderDetails }),
            _react2.default.createElement(_reactRouter.Route, { path: 'payment-order/:order_id', component: _containers.PaymentOrder }),
            _react2.default.createElement(
                _reactRouter.Route,
                { path: 'personal', component: _containers.Personal, onEnter: onEnter, onLeave: onLeave },
                _react2.default.createElement(_reactRouter.IndexRedirect, { to: 'profile' }),
                _react2.default.createElement(_reactRouter.Route, { path: 'order-list', component: _containers.OrderList }),
                _react2.default.createElement(_reactRouter.Route, { path: 'addresses', component: _AddressList2.default }),
                _react2.default.createElement(_reactRouter.Route, { path: 'order/:order_id', component: _containers.OrderDetail, onEnter: onEnterToOrderDetails }),
                _react2.default.createElement(_reactRouter.Route, { path: 'profile', component: _containers.Profile }),
                _react2.default.createElement(_reactRouter.Route, { path: 'wishlist', component: _containers.WishList }),
                _react2.default.createElement(_reactRouter.Route, { path: 'basket', component: _containers.PersonalBasket }),
                _react2.default.createElement(_reactRouter.Route, { path: 'operations', component: _containers.Operations })
            )
        ),
        _react2.default.createElement(_reactRouter.Route, { path: 'registration', onEnter: onEnterRegPage, component: _containers.Registration }),
        _react2.default.createElement(_reactRouter.Route, { path: 'product/:id', component: _containers.CartProduct }),
        _react2.default.createElement(_reactRouter.Route, { path: 'basket', component: _containers.Basket }),
        _react2.default.createElement(_reactRouter.Route, { path: 'basket/:code', component: _containers.ShareBasket }),
        _react2.default.createElement(_reactRouter.Route, { path: 'wishlist', component: _containers.WishList }),
        _react2.default.createElement(_reactRouter.Route, { path: 'postpone', component: _containers.PostponeBasket }),
        _react2.default.createElement(_reactRouter.Route, { path: 'category/:id', component: _containers.Category, onEnter: onEnter, onLeave: onLeave }),
        _react2.default.createElement(_reactRouter.Route, { path: 'search/:input_state', component: _containers.Search }),
        _react2.default.createElement(_reactRouter.Route, { path: 'slide', component: _containers.Slide, settings: { includeOnlineAdvisorCode: false } }),
        _react2.default.createElement(_reactRouter.Route, { path: 'page/:page_url', component: _containers.Page }),
        _react2.default.createElement(_reactRouter.Route, { path: '*', component: _containers.NotFound, status: 404 })
    );
};

// Получаем кастомные настройки с роута <Route path="/" settings={{ opt1: true }}>


function getRouteSettings(routes) {
    var settings = {};
    if (Array.isArray(routes)) {
        routes.forEach(function (route) {
            if ((0, _typeof3.default)(route.settings) === 'object') {
                (0, _lodash.merge)(settings, route.settings);
            }
        });
    } else if ((0, _lodash.isPlainObject)(routes)) {
        if ((0, _typeof3.default)(routes.settings) === 'object') {
            (0, _lodash.merge)(settings, route.settings);
        }
    }

    return settings;
}


//////////////////
// WEBPACK FOOTER
// ./src/routes.js
// module id = 1919
// module chunks = 0